<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" class="text-right">
							{{ currentdate | formatDateTime }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<div class="mx-8 my-6" v-if="data.datasets.ds.length">
					<v-divider></v-divider>
					<v-simple-table dense>
						<template v-slot:default>
						<thead>
							<tr>
								<th>Марка</th>
								<th>Рік</th>
								<th>Ціна UAH</th>
								<th>Ціна USD</th>
								<th>Кількість</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in data.datasets.ds" :key="index">
								<td>{{ item.BrandName }}</td>
								<td>{{ item.yearProd }}</td>
								<td><span v-if="Number(item.avgPriceUAH)">{{ parseInt(item.avgPriceUAH) | toMoney }}</span></td>
								<td><span v-if="Number(item.avgPriceUSD)">{{ parseInt(item.avgPriceUSD) | toMoney }}</span></td>
								<td>{{ item.cnt }}</td>
							</tr>
						</tbody>
						<tfoot>
							<tr class="font-weight-bold">
								<td>Всього</td>
								<td></td>
								<td></td>
								<td></td>
								<td>{{ total }}</td>
							</tr>
						</tfoot>
					</template>
					</v-simple-table>
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },
	computed: {
		total() {
			const initialValue = 0;
			const sumWithInitial = this.data.datasets.ds.reduce(
				(accumulator, element) => accumulator + parseInt(element.cnt),
				initialValue,
			);

			return sumWithInitial
		}
	},
}

</script>